import { render, staticRenderFns } from "./IFilter.vue?vue&type=template&id=5dda9d26&scoped=true&"
import script from "./IFilter.vue?vue&type=script&lang=js&"
export * from "./IFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dda9d26",
  null
  
)

export default component.exports